// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabAttachedRequestsSubTabs-modulesubTabs__tG2xg EntityTabSubTabs-moduleEntityTabSubTabs__c4_31";
export { _1 as "subTabs" }
